import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { HtmlTagOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTextBox, TextBoxComponent } from '../../common/text-box/text-box.component';
import { defaultImage } from '../../icms.config';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';

let uid = 0;
export namespace NCmsQuickLinks {
    export interface IComponentData extends NICmsContentComponent.IData, NTextBox.IData {
        /**
         * Links list
         */
        links: IQuickLink[];
    }
    export interface IQuickLink {
        title: string;
        titleTag?: string;
        link: string;
        image: string;
    }
}

@ICmsComponent<CmsQuickLinksComponent>({
    id: 'quick-links',
    name: 'Quick Links',
    tags: ['categories', 'carousel', 'quick links', 'links'],
    fields: [
        ...NTextBox.getFields(false, false),
        // links
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Links',
            itemName: 'Link',
            itemNameField: 'title',
            required: true,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Quicklink',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    key: 'titleTag',
                    title: 'Title Tag',
                    type: NICmsContentField.EFieldType.choice,
                    options: HtmlTagOptions
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link',
                    default: '/',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    default: defaultImage,
                    required: true
                }
            ],
            defaultSize: 4
        }
    ]
})
@Component({
    standalone: true,
    imports: [TextBoxComponent, SizeClassDirective, DfUiCarouselModule, HrefComponent, DfModuleImageModule, ICmsClientModule],
    selector: 'cms-quick-links',
    templateUrl: './cms-quick-links.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsQuickLinks.IComponentData;
    protected uid = uid++;
    get pcSlides() {
        return [3.3, 6.3, 9, 9][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return [12, 20, 30, 35][this.client.sizeId] + 'px';
    }

    get canMove() {
        return this.component?.links?.length && this.component.links.length > this.pcSlides;
    }
}
